export default {
    state: {
        standards: []
    },
    mutations: {
        setStandards (state, payload) {
            state.standards = payload
        }
    },
    actions: {
        getStandards (context, publication_id) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/publications/standards/' + publication_id)
                .then(response => {
                    context.commit('setStandards', response.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
